class CountdownDelivery extends HTMLElement {
  constructor() {
    super();
    this.interval = null; // Stocke l'intervalle pour mise à jour du compte à rebours
  }

  // Méthode appelée lorsque l'élément est inséré dans le DOM
  connectedCallback() {
    // Lire l'attribut `data-delivery-date`
    const deliveryDate = this.getAttribute("data-delivery-date");
    if (!deliveryDate) {
      this.innerHTML = "Aucune date définie pour le compte à rebours.";
      return;
    }

    // Convertir la date en objet Date
    this.targetDate = new Date(deliveryDate);
    if (isNaN(this.targetDate)) {
      this.innerHTML = "Format de date invalide.";
      return;
    }

    // Initialiser le compte à rebours
    this.startCountdown();
  }

  // Méthode appelée lorsque l'élément est retiré du DOM (nettoyage)
  disconnectedCallback() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  // Démarrer le compte à rebours
  startCountdown() {
    this.updateCountdown(); // Mettre à jour immédiatement
    this.interval = setInterval(() => {
      this.updateCountdown();
    }, 1000);
  }

  // Mettre à jour l'affichage
  updateCountdown() {
    const now = new Date();
    const diff = this.targetDate - now;

    if (diff <= 0) {
      this.innerHTML = "Le compte à rebours est terminé.";
      clearInterval(this.interval);
      return;
    }

    // Calcul du temps restant
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    // Affichage formaté
    this.innerHTML = `
      ${days > 0 ? `${days} j, ` : ""}
      ${hours} h, 
      ${minutes} m et 
      ${seconds} s.
    `;
  }
}

// Enregistrer le composant personnalisé
customElements.define("countdown-delivery", CountdownDelivery);